import { render, staticRenderFns } from "./withdrawMoneyInfo.vue?vue&type=template&id=18d550c2&scoped=true&"
import script from "./withdrawMoneyInfo.vue?vue&type=script&lang=js&"
export * from "./withdrawMoneyInfo.vue?vue&type=script&lang=js&"
import style0 from "./withdrawMoneyInfo.vue?vue&type=style&index=0&id=18d550c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d550c2",
  null
  
)

export default component.exports